import { configureStore } from '@reduxjs/toolkit';
import authSlice from './store-slice/auth-slice'
import dashboardSlice from './store-slice/dashboard-slice'
import filesSlice from './store-slice/files-slice'
import settingSlice from './store-slice/settings-slice';
import homePageSlice from './store-slice/homepage-slice'
import legalSettingSlice from './store-slice/legal-slice'
import mediaSlice from './store-slice/media-slice';
import contactManagementSlice from './store-slice/contact-management-slice';
import analyticsSlice from './store-slice/analytics-slice';
import liveShareSlice from './store-slice/live-share-slice';
import blogsReducer from './store-slice/blog-slice';
import emailSlice from './store-slice/email-slice';
import brandingSlice from './store-slice/branding-slice';
import uploadAttemptsReducer from './store-slice/upload-attempt-slice';
import newsletterSlice from './store-slice/newsletter-slice';
import pricingSlice from './store-slice/pricing-slice';
import updatesReducer from './store-slice/updates-slice';
import logsSlice from './store-slice/logs-slice';
import filesBackupSlice from './store-slice/files-backup-slice';

const store = configureStore({
	reducer: {
		auth: authSlice,
		dashboard: dashboardSlice,
		files: filesSlice,
		setting: settingSlice,
		homepage: homePageSlice,
		legalSetting: legalSettingSlice,
		contactManage: contactManagementSlice,
		media: mediaSlice,
		analytics: analyticsSlice,
		liveShares: liveShareSlice,
		blogs: blogsReducer,
		emails: emailSlice,
		branding: brandingSlice,
		uploadAttempts: uploadAttemptsReducer,
		newsLetter: newsletterSlice,
		pricing: pricingSlice,
		updates: updatesReducer,
		logs: logsSlice,
		filesBackup: filesBackupSlice
	},
});


export default store;